import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const isFor = ['Solo hosts who manage their own turnovers.', "New hosts terrified of their first 'Instant Book' surprise.", "'Accidental' hosts who have a full-time job and limited time.", 'Anyone who wants to stop paying $150+ for cleaning crews and keep the profit.'];
const notFor = ['Large property management firms with full cleaning staffs.', "People looking for a guide on 'deep cleaning' or restoration.", "Hosts who aren't willing to follow a strict, high-speed system."];
export function WhoFor() {
  return <section className="bg-gray-50 py-24" data-id="element-158">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-160">
          {/* WHO THIS IS FOR */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl shadow-xl p-8 sm:p-10 border-t-8 border-green-500" data-id="element-161">
            <h2 className="text-3xl sm:text-4xl text-brand-dark mb-8" data-id="element-162">
              WHO THIS IS <span className="text-green-600" data-id="element-163">FOR</span>
            </h2>
            <ul className="space-y-6" data-id="element-164">
              {isFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-165">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-166" />
                  <span className="text-lg text-gray-700 font-medium" data-id="element-167">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* WHO THIS IS NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl shadow-xl p-8 sm:p-10 border-t-8 border-red-500" data-id="element-168">
            <h2 className="text-3xl sm:text-4xl text-brand-dark mb-8" data-id="element-169">
              WHO THIS IS <span className="text-red-600" data-id="element-170">NOT FOR</span>
            </h2>
            <ul className="space-y-6" data-id="element-171">
              {notFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-172">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-173" />
                  <span className="text-lg text-gray-700 font-medium" data-id="element-174">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}